/* tslint:disable */
/* eslint-disable */
/**
 * HashiCorp Cloud Platform Waypoint
 * Service for managing applications.
 *
 * The version of the OpenAPI document: 2024-11-22
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { HashicorpCloudWaypointV20241122ActionCfgRefFromJSON, HashicorpCloudWaypointV20241122ActionCfgRefToJSON, HashicorpCloudWaypointV20241122ActionConfigFromJSON, HashicorpCloudWaypointV20241122ActionConfigToJSON, HashicorpCloudWaypointV20241122ActionConfigRequestFromJSON, HashicorpCloudWaypointV20241122ActionConfigRequestToJSON, HashicorpCloudWaypointV20241122ActionRunResponseStatusFromJSON, HashicorpCloudWaypointV20241122ActionRunResponseStatusToJSON, HashicorpCloudWaypointV20241122ActionRunScopeFromJSON, HashicorpCloudWaypointV20241122ActionRunScopeToJSON, HashicorpCloudWaypointV20241122ActionRunVariableFromJSON, HashicorpCloudWaypointV20241122ActionRunVariableToJSON, HashicorpCloudWaypointV20241122JobFromJSON, HashicorpCloudWaypointV20241122JobToJSON, HashicorpCloudWaypointV20241122RefNamespaceFromJSON, HashicorpCloudWaypointV20241122RefNamespaceToJSON, HashicorpCloudWaypointV20241122StatusLogFromJSON, HashicorpCloudWaypointV20241122StatusLogToJSON, } from './';
export function HashicorpCloudWaypointV20241122ActionRunFromJSON(json) {
    return HashicorpCloudWaypointV20241122ActionRunFromJSONTyped(json, false);
}
export function HashicorpCloudWaypointV20241122ActionRunFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'namespace': !exists(json, 'namespace') ? undefined : HashicorpCloudWaypointV20241122RefNamespaceFromJSON(json['namespace']),
        'sequence': !exists(json, 'sequence') ? undefined : json['sequence'],
        'actionConfig': !exists(json, 'action_config') ? undefined : HashicorpCloudWaypointV20241122ActionConfigFromJSON(json['action_config']),
        'createdAt': !exists(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'completedAt': !exists(json, 'completed_at') ? undefined : (new Date(json['completed_at'])),
        'runBy': !exists(json, 'run_by') ? undefined : json['run_by'],
        'responseStatus': !exists(json, 'response_status') ? undefined : HashicorpCloudWaypointV20241122ActionRunResponseStatusFromJSON(json['response_status']),
        'statusLog': !exists(json, 'status_log') ? undefined : (json['status_log'].map(HashicorpCloudWaypointV20241122StatusLogFromJSON)),
        'request': !exists(json, 'request') ? undefined : HashicorpCloudWaypointV20241122ActionConfigRequestFromJSON(json['request']),
        'scope': !exists(json, 'scope') ? undefined : HashicorpCloudWaypointV20241122ActionRunScopeFromJSON(json['scope']),
        'backgroundJob': !exists(json, 'background_job') ? undefined : HashicorpCloudWaypointV20241122JobFromJSON(json['background_job']),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'actionConfigRef': !exists(json, 'action_config_ref') ? undefined : HashicorpCloudWaypointV20241122ActionCfgRefFromJSON(json['action_config_ref']),
        'variables': !exists(json, 'variables') ? undefined : (json['variables'].map(HashicorpCloudWaypointV20241122ActionRunVariableFromJSON)),
    };
}
export function HashicorpCloudWaypointV20241122ActionRunToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'namespace': HashicorpCloudWaypointV20241122RefNamespaceToJSON(value.namespace),
        'sequence': value.sequence,
        'action_config': HashicorpCloudWaypointV20241122ActionConfigToJSON(value.actionConfig),
        'created_at': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'completed_at': value.completedAt === undefined ? undefined : (value.completedAt.toISOString()),
        'run_by': value.runBy,
        'response_status': HashicorpCloudWaypointV20241122ActionRunResponseStatusToJSON(value.responseStatus),
        'status_log': value.statusLog === undefined ? undefined : (value.statusLog.map(HashicorpCloudWaypointV20241122StatusLogToJSON)),
        'request': HashicorpCloudWaypointV20241122ActionConfigRequestToJSON(value.request),
        'scope': HashicorpCloudWaypointV20241122ActionRunScopeToJSON(value.scope),
        'background_job': HashicorpCloudWaypointV20241122JobToJSON(value.backgroundJob),
        'id': value.id,
        'action_config_ref': HashicorpCloudWaypointV20241122ActionCfgRefToJSON(value.actionConfigRef),
        'variables': value.variables === undefined ? undefined : (value.variables.map(HashicorpCloudWaypointV20241122ActionRunVariableToJSON)),
    };
}
